import { useState } from "react";
import { Link } from "react-router-dom";
import arrowdown from " ../../../src/Assets/arrowdown.svg";
import Sidebar from "../../components/consolecomponents/sidebar/Sidebar";
import { useAllProjects } from "../../hooks/DevProjectHooks";
import ConsoleLocalStorage from "../../storage/storage";
import Navbar from "../../components/Navbar"
import { PrimaryButton } from "../../components/forms/button";

const JoinDiscord = () => {
  const [showSideBarList, setShowSidebarList] = useState(false);
  const [join, setJoin] = useState(ConsoleLocalStorage.getDiscordJoined);
  const [verified, setVerified] = useState(ConsoleLocalStorage.getDiscordVerified);
  const [inviteUrl, setInviteUrl] = useState(ConsoleLocalStorage.getDiscordInviteUrl);
  const [accessUrl, setAccessUrl] = useState(ConsoleLocalStorage.getDiscordAccessUrl);

  const {
    data: projects,
  } = useAllProjects();
  
  return (
    <>
      <Navbar showSignup={false} clickDisabled={false} />
      <div className="text-white d-flex ">
        <Sidebar>
          <section className="">
            <div
              onClick={() => setShowSidebarList(!showSideBarList)}
              className="sidebar_projects"
            >
              <h3 className="">
                {`All Projects (${projects?.length})`}
                <img
                  src={arrowdown}
                  alt="logo"
                  className="mr-1 fluid logo"
                  style={{
                    width: "0.75rem",
                    height: "0.75rem",
                    marginLeft: "0.25rem",
                  }}
                />
              </h3>
              {showSideBarList ? (
                <ul className="sidebar_projectlist">
                  {projects.map((project) => (
                    <li key={project.id}>
                      <Link to={`/console/${project.id}`}>
                        <span className="sidebar_list_items">
                          {project.name}
                        </span>{" "}
                      </Link>
                    </li>
                  ))}
                </ul>
              ) : null}
            </div>
          </section>
        </Sidebar>
        <div className="container d-flex d-flex-column d-align-center mtc-40">

          <div className="mtc-30">
            {join && verified &&
              <div>
                <div className="mbc-25">
                  <span className="font-size-32 theme__font--bold">Access JioGlass Discord Server</span>
                </div>
                <div className="d-flex d-justify-center">

                  <a href={`${accessUrl}`} className="button primary-button font-size-14" target="_blank">Access Discord</a>
                  </div>
              </div>
            }
            {!join && verified &&
              <div>
                <div className="mbc-25">
                  <span className="font-size-32 theme__font--bold">Join the JioGlass Developers Community on Discord</span>
                </div>
                <div className="d-flex d-justify-center">
                <a href={`${inviteUrl}`} className="button primary-button font-size-14" target="_blank">Join Discord</a>
                  </div>
              </div>
            }
          </div>
          <div className="mtc-25">
            <span className="font-size-18 theme__font--medium">
              Get access to our exclusive XR Developers Community for any technical guidance and support.
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default JoinDiscord;
